import { Insurability } from "model/insurability.model";

/** ---- Dispatch Types ---- */
export const LOAD_INSURABILITY_START = "LOAD_INSURABILITY_START";
export const LOAD_INSURABILITY_SUCCESS = "LOAD_INSURABILITY_SUCCESS";
export const LOAD_INSURABILITY_ERROR = "LOAD_INSURABILITY_ERROR";
export const LOAD_CHRONIC_INFORMATION = "LOAD_CHRONIC_INFORMATION";

/** ---- Dispatch Interfaces ---- */
interface LoadInsurabilityStartAction {
  type: typeof LOAD_INSURABILITY_START;
}

interface LoadInsurabilitySuccessAction {
  type: typeof LOAD_INSURABILITY_SUCCESS;
  payload: Insurability;
}

interface LoadInsurabilityErrorAction {
  type: typeof LOAD_INSURABILITY_ERROR;
}

interface LoadChronicInformation {
  type: typeof LOAD_CHRONIC_INFORMATION;
  payload: boolean;
}

export type InsurabilityAction =
  | LoadInsurabilityStartAction
  | LoadInsurabilitySuccessAction
  | LoadInsurabilityErrorAction
  | LoadChronicInformation;
